export default __webpack_public_path__ + "media/components/map_controls/ZoomControls/pro-badge-d3eaa67b90ec9d89334bd868284d0a86.svg";